import React, { PropTypes } from 'react';
import {
  getDepartmentLabel,
  getRegionLabel,
  getProfileLabel,
} from '../../diffusion/api/index';

export class DiffusionTarget extends React.Component {
  static propTypes = {
    target: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    isEditable: PropTypes.bool.isRequired,
  };

  render() {
    const { target, onDelete, isEditable } = this.props;
    return (
      <tr>
        <td>
          {target.profile && (
            <div className="ui label">{getProfileLabel(target.profile)}</div>
          )}
        </td>
        <td>
          {target.region && (
            <div className="ui label">{getRegionLabel(target.region)}</div>
          )}
        </td>
        <td>
          {target.department && (
            <div className="ui label">
              {getDepartmentLabel(target.department)}
            </div>
          )}
        </td>
        <td>
          {target.tags.map(l => (
            <div key={'tag_' + l} className="ui label">
              {l}
            </div>
          ))}
        </td>
        <td className="right aligned">
          {isEditable && (
            <a className="ui red icon button" onClick={onDelete}>
              <i className="icon remove" />
            </a>
          )}
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/news/components/DiffusionTarget.js